// extracted by mini-css-extract-plugin
export default {"background":"DeleteModal_background__DQYfZ","modal":"DeleteModal_modal__UNixP","modal-title":"DeleteModal_modal-title__UQUTb","modal-warning":"DeleteModal_modal-warning__F3JYF"};